module.exports = __webpack_public_path__ + "img/IGadaWarrior64_ua.57e52381.webp";